__turbopack_context__.v({
  "container": "_8tMbPa_container",
  "content": "_8tMbPa_content",
});
